// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2IZrm","footer":"ModalCreateQualiphyProcedure_footer__1rFf-","additionData":"ModalCreateQualiphyProcedure_additionData__ixk20"};